import { render, staticRenderFns } from "./OCRView.vue?vue&type=template&id=5b3c6e3d&"
import script from "./OCRView.vue?vue&type=script&lang=js&"
export * from "./OCRView.vue?vue&type=script&lang=js&"
import style0 from "./OCRView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OCRView.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports